import { Check } from 'lucide-react';
import { PLATFORM_FEE_NOTE, SAAS_PLANS } from 'modules/arena/onboarding/content';
import { Card } from 'shared/components/ui/Card';
import { cn } from 'shared/utils/cn';
import { ArenaOnboardingState } from 'modules/arena/onboarding/useArenaOnboarding';

export function StepPlan(state: ArenaOnboardingState) {
  return (
    <div>
      <p className="text-sm text-ink-secondary">Escolha o plano SaaS da sua arena.</p>

      <div className="mt-4 grid gap-3 sm:grid-cols-3">
        {SAAS_PLANS.map((plan) => {
          const isSelected = plan.id === state.planId;

          return (
            <Card
              key={plan.id}
              className={cn(
                'cursor-pointer',
                isSelected ? 'border-primary ring-1 ring-primary' : 'hover:border-primary'
              )}
            >
              <button
                type="button"
                onClick={() => state.setPlanId(plan.id)}
                className="flex w-full flex-col items-start text-left"
              >
                <p className="font-heading font-semibold text-ink">{plan.name}</p>
                <p className="mt-1 font-heading text-2xl font-bold text-primary">
                  R$ {plan.price}
                  <span className="text-sm font-normal text-ink-secondary">/mês</span>
                </p>
                <ul className="mt-3 flex flex-col gap-1 text-sm text-ink-secondary">
                  {plan.features.map((feature) => (
                    <li key={feature} className="flex items-start gap-2">
                      <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-success" strokeWidth={2.5} aria-hidden="true" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </button>
            </Card>
          );
        })}
      </div>

      <p className="mt-4 text-xs text-ink-secondary">{PLATFORM_FEE_NOTE}</p>
    </div>
  );
}
